module.exports = __webpack_public_path__ + "static/img/p2_img.01895a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p2_img.png
// module id = knbU
// module chunks = 0